import { render, staticRenderFns } from "./ManageProgram.vue?vue&type=template&id=2b6b20c5&scoped=true"
import script from "./ManageProgram.vue?vue&type=script&lang=js"
export * from "./ManageProgram.vue?vue&type=script&lang=js"
import style0 from "./ManageProgram.vue?vue&type=style&index=0&id=2b6b20c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6b20c5",
  null
  
)

export default component.exports